import moment from 'moment';

moment.locale('nl');

/**
 * Format a date based on a momentjs format
 */

export const formatDate = (value: string, format: string): string => {
    return `${(value && !value.includes('1970-01-01')) ? moment(value).format(format) : '-'}`;
}

export const dateToIso = (value: string): string => {
    return `${value ? moment(value, 'DD-MM-YYYY').toISOString(true) : ''}`;
}

export const isValidDate = (value: string): boolean => {
    const validator = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
    return validator.test(value)
}
export const isoToDate = (value: string): string => {
    return `${value ? moment(value).format('DD-MM-YYYY') : ''}`;
}

export const getYear = (value: string): string => {
    return `${value ? moment(value).format('YYYY') : ''}`;
}

export const getDay = (value: string): string => {
    return `${value ? moment(value).format('D') : ''}`;
}
